import ContactSupportPage from "@/app/app-shared/contact-support";
import RegistrationPage from "@/app/registration/page";
import XeroConnectConfirmation from "@/components/xero-payment/connect-confirmation";
import { routes } from "@/config/routes";
import ForgetPassword from "@/page/ForgetPassword";
import SignIn from "@/page/SignIn";
import VerifyOtpPage from "@/page/verify-otp/VerifyOtpPage";
import { publicRoutesType } from "@/types/routes";
import withOutAuth from "@/hocs/withOutAuth";
import { Fragment } from "react/jsx-runtime";
import { PublicLeadDetailsPage } from "@/page/enquiry-entries/PublicLeadDetailsPage";

export const publicRoutes: publicRoutesType[] = [
  {
    path: routes.auth.signUp,
    component: RegistrationPage,
    layout: withOutAuth(Fragment),
  },
  {
    path: routes.auth.signIn,
    component: SignIn,
    layout: withOutAuth(Fragment),
  },
  {
    path: routes.auth.forgotPassword,
    component: ForgetPassword,
    layout: withOutAuth(Fragment),
  },

  {
    path: routes.auth.verifyOtp,
    component: VerifyOtpPage,
    layout: withOutAuth(Fragment),
  },

  {
    path: routes.contactSupport,
    component: ContactSupportPage,
    layout: Fragment,
  },

  {
    path: routes.xeroPaymentCallback,
    component: XeroConnectConfirmation,
    layout: withOutAuth(Fragment),
  },
  // Public lead details page
  {
    ...PublicLeadDetailsPage,
  },
];
